import axios from "axios";

const BASE_URL = process.env.VUE_APP_SERVER_URL + "api/dashboard";

class DashboardService {
    async getStatus() {
        let result = null;
        await axios.get(`${BASE_URL}/getstatus`, {headers: {'Access-Control-Allow-Origin': '*'}})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            })
        return result;
    }
    async getLogin(login, pwd) {
        let result = null;
        let pkg = {
            login: login,
            password: pwd
        }
        await axios.post(`${BASE_URL}/login`, pkg, {headers: {'Access-Control-Allow-Origin': '*'}})
            .then((res) => {
                if(res.data.accessToken){
                    localStorage.setItem('login', JSON.stringify(res.data));
                }
                location.reload(true)
                result = res;
            })
            .catch((err) => {
                console.log(err)
                window.alert(err.response.data.message)
            })
        return result;
    }
    async register(login, email, password) {
        let result = null;
        let register = {
            login: login,
            email: email,
            password: password
        }
        await axios.post(`${BASE_URL}/register`, register, {headers: {'Access-Control-Allow-Origin': '*'}})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
                return err;
            })
        return result;
    }
    async getHomePage(idproject) {
        let result = null;
        await axios.get(`${BASE_URL}/${idproject}/homepage`, {headers: {'Access-Control-Allow-Origin': '*'}})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            })
        return result;
    }
    async getWebPages(idproject) {
        let result = null;
        await axios.get(`${BASE_URL}/${idproject}/webpages`, {headers: {'Access-Control-Allow-Origin': '*'}})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            })
        return result;
    }
    async updateDashboards(idproject, ids) {
        let result = null;
        await axios.post(`${BASE_URL}/${idproject}/updatedashboards?ids=${ids}`, {headers: {'Access-Control-Allow-Origin': '*'}})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            })
        return result;
    }
}

export default new DashboardService;